import nlNL from "../../../i18n/nl-NL/common.json";
import deDE from "../../../i18n/de-DE/common.json";
import { getMarketContext } from "../config/market-context.js";
import { createTranslator } from "./translator.js";

const translations = {
  "nl-NL": nlNL,
  "de-DE": deDE,
};

export function getI18n(context = getMarketContext()) {
  const messages = translations[context.locale];
  if (!messages) {
    throw new Error(`Unsupported Wallable locale: ${context.locale}`);
  }

  return createTranslator({
    locale: context.locale,
    currency: context.currency,
    messages,
    fallbackMessages: nlNL,
  });
}
